import { useState, useEffect } from "react";
import { getMailchimpAudienceList } from "../../api/AppLinkApi";
import Input from "../../components/Input";
import DropdownLayout from "../../components/DropdownLayout";
import { useTranslation } from "react-i18next";

const MailChimpAudiencePicker = ({ onChange, defaultName = "no assigned list" }) => {
  const { t } = useTranslation();
  const [list, setList] = useState<any>([]);
  const [selectedName, setSelectedName] = useState<any>(defaultName);
  const [searchValue, setSearchValue] = useState<any>("");
  const [errorMessage, setErrorMessage] = useState<any>("");

  useEffect(() => {
    getMailchimpAudienceList()
      .then((data) => {
        const items = data.lists || [];
        if (items.length == 0) {
          setList([]);
          setErrorMessage(t("No list in Mailchimp"));
        } else {
          const mappedItems = items.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setList(mappedItems);
        }
      })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderItems = () => {
    const filteredItems =
      searchValue == "" ? list : list.filter((channel) => channel.label.includes(searchValue));
    return filteredItems.map((item) => {
      return (
        <li
          key={`automation_${item.value}`}
          className={"hover:text-blue-600 cursor-pointer"}
          onClick={() => {
            setSelectedName(item.label);
            onChange(item);
          }}
        >
          {item.label}
        </li>
      );
    });
  };

  const renderDisplay = () => {
    if (errorMessage != "") {
      return <div className={"text-red-600"}>{t(errorMessage)}</div>;
    }
    return (
      <div className={"flex space-x-1"}>
        <div className={"truncate ..."}>{selectedName || t("no selectedName")}</div>
      </div>
    );
  };

  const act = (
    <div
      className={
        "w-full flex space-x-1.5 align-middle cursor-pointer text-gray-600 hover:border-b hover:border-b-blue-600 px-2 font-semibold"
      }
    >
      {renderDisplay()}
    </div>
  );

  if (list.length == 0) {
    return act;
  }

  return (
    <DropdownLayout fullWidth={false} activator={act} positionClassName={"left-0 origin-top-left"}>
      <>
        <div className={"p-4 w-52"}>
          <Input
            placeholder={t("Search...")}
            value={searchValue}
            onChange={(value) => {
              setSearchValue(value);
            }}
          />
        </div>
        <div className={"max-h-80 overflow-y-scroll"}>
          <ul className="px-2 space-y-2">{renderItems()}</ul>
        </div>
      </>
    </DropdownLayout>
  );
};

export default MailChimpAudiencePicker;
